// Products a visitor can request a quote for, and where "Buy Now" links go.
export const QUOTE_PRODUCTS = [
  { pn: 'B00033', label: 'UL101 Aviation Troubleshooter', path: '/products/ul101', avionteq: 'https://www.avionteq.com/CTRL-Systems-B00033-UL101-Aviation-Troubleshooter' },
  { pn: 'B00700', label: 'UL101 Troubleshooter + H6 Acoustic Camera', path: '/products/combo-kits/b00700', avionteq: 'https://www.avionteq.com/CTRL-Systems-B00700-UL101-H6-combination-kit' },
  { pn: 'B00705', label: 'UL101 Troubleshooter + H4mini Acoustic Camera', path: '/products/combo-kits/b00705', avionteq: 'https://www.avionteq.com/CTRL-Systems-B00705-UL101-H4mini-combination-kit' },
  { pn: 'F00042', label: 'H4mini Acoustic Camera', path: '/products/acoustic-cameras/h4mini', avionteq: 'https://www.avionteq.com/CTRL-Systems-F00042-H4mini-acoustic-imaging-camera' },
  { pn: 'F00061', label: 'H6 Acoustic Camera', path: '/products/acoustic-cameras/h-series', avionteq: 'https://www.avionteq.com/CTRL-Systems-F00061-H6-acoustic-imaging-camera' },
];

export const OTHER_PRODUCT = 'Other';

export const QUOTE_SOURCES = [
  { id: 'barfield', label: 'Barfield', sub: 'Miami, FL · global distribution' },
  { id: 'avionteq', label: 'AvionTEq', sub: 'Van Nuys, CA · global distribution' },
  { id: 'ctrl', label: 'CTRL direct', sub: 'Manufacturer' },
];

export const quoteProduct = (pn) => QUOTE_PRODUCTS.find((p) => p.pn === pn);

// Map whatever a page passes (P/N, legacy 'UL101', or a product name) to a quote product P/N or 'Other'.
export const resolveQuoteProduct = (value) => {
  if (!value) return { product: 'B00033', other: '' };
  if (quoteProduct(value)) return { product: value, other: '' };
  const v = String(value).toLowerCase();
  if (v.includes('ul101') && v.includes('h6')) return { product: 'B00700', other: '' };
  if (v.includes('ul101') && v.includes('h4mini')) return { product: 'B00705', other: '' };
  if (v.includes('ul101') || v === 'b00033') return { product: 'B00033', other: '' };
  if (v.includes('h4mini')) return { product: 'F00042', other: '' };
  if (v.includes('h6') && !v.includes('h4')) return { product: 'F00061', other: '' };
  return { product: OTHER_PRODUCT, other: String(value) };
};
